import digitalData from 'digital-data';
import { setAnalytics, getCategoryBreadCrumbs, getHeaderCrumb } from '../../../thd-analytics-utils.js';
import { PRODUCT_VIEW, BIP_PAGE, PAGE_DEFAULT_TEMPLATE, NUCLEUS } from '../../../constants.js';
import { getProductInfo } from './bip.utils.js';
export function bip() {
  window.LIFE_CYCLE_EVENT_BUS.on('bip.page-load', _ref => {
    var _product$taxonomy;
    let {
      output
    } = _ref;
    const {
      product,
      products
    } = output;
    const parentBreadCrumbs = product === null || product === void 0 ? void 0 : (_product$taxonomy = product.taxonomy) === null || _product$taxonomy === void 0 ? void 0 : _product$taxonomy.breadCrumbs;
    digitalData.page = {
      pageInfo: {
        pageName: getHeaderCrumb(parentBreadCrumbs),
        pageLoadEvent: PRODUCT_VIEW,
        platform: NUCLEUS,
        pageType: BIP_PAGE,
        pageTemplate: PAGE_DEFAULT_TEMPLATE,
        packageID: product === null || product === void 0 ? void 0 : product.itemId
      },
      category: getCategoryBreadCrumbs(parentBreadCrumbs)
    };
    digitalData.product = getProductInfo(products);
    setAnalytics(digitalData);
  });
}
//# sourceMappingURL=bip.js.map